import { useBindingOperations } from "./useBindingOperations.js";
const usePersist = () => useBindingOperations().persist;
export {
  usePersist
};
//# sourceMappingURL=usePersist.js.map
